import { Box, Card, Divider, Skeleton } from '@mui/material';
import {
  FRAGMENT_CARD_PADDING_X,
  FRAGMENT_LIST_CARD_MEDIA_WIDTH,
  FRAGMENT_LIST_CONTAINER_SX,
} from '../../fragment-card/constants';

/**
 * Compact horizontal list skeleton matching FragmentCardListBase layout:
 * media thumbnail | title + time | divider | relative time | divider | status icons.
 */
export function FragmentCardListSkeleton() {
  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'stretch',
        width: '100%',
        ...FRAGMENT_LIST_CONTAINER_SX,
        p: FRAGMENT_CARD_PADDING_X,
        gap: FRAGMENT_CARD_PADDING_X,
      }}
    >
      {/* Media: fixed width, 16/9 aspect for compact height (matches list video card). */}
      <Box
        sx={{
          width: FRAGMENT_LIST_CARD_MEDIA_WIDTH,
          minWidth: FRAGMENT_LIST_CARD_MEDIA_WIDTH,
          overflow: 'hidden',
          borderRadius: 1,
        }}
      >
        <Skeleton
          variant="rectangular"
          sx={{ width: '100%', height: 'auto', aspectRatio: '16/9' }}
        />
      </Box>

      {/* Title + secondary line */}
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          pl: 1,
          minWidth: 0,
        }}
      >
        <Skeleton width="70%" height={20} sx={{ maxWidth: 280 }} />
        <Box sx={{ mt: 0.75, display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Skeleton width={100} height={16} />
          <Skeleton width={48} height={16} />
        </Box>
      </Box>

      <Divider orientation="vertical" flexItem />

      {/* Relative time */}
      <Box
        sx={{
          width: 300,
          minWidth: 250,
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Skeleton width={90} height={16} />
      </Box>

      <Divider orientation="vertical" flexItem />

      {/* Status icons */}
      <Box
        sx={{
          width: 140,
          minWidth: 120,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 0.5,
        }}
      >
        {[1, 2, 3, 4, 5].map((i) => (
          <Skeleton key={i} variant="rounded" width={20} height={20} />
        ))}
      </Box>
    </Card>
  );
}
